import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core'
import { ValidatedRadioButtonModel } from '../../../../../validations/validated-radio-button-group.component'
import { ValidatedTextField } from '../../../../../validations/validated-text-field.component'
import { NumericTextFieldValidator } from '../../../../../validations/numeric-text-field-validator'
import { ValidatedDateTextField } from '../../../../../validations/validated-date-text-field.component'
import { NotBlankGenericFieldValidator } from '../../../../../validations/not-blank-generic-field-validator'
import { EnrollmentViewModel } from '../../../../models/enrollment-view-model'
import { Router } from '@angular/router'
import { PortalGlobals } from '../../../../../portalglobals'
import { EnrollmentGateway } from '../../../../gateways/enrollment-gateway'
import * as moment from 'moment'
import { SubmitEnrollmentDataResponse } from '../../../../models/submit-enrollment-data-response'

@Component({
    selector: 'PhoneEnrollmentExtStep2',
    templateUrl: 'phone-enrollment-step2.component.html',
    styleUrls: ['../phone-enrollment.component.scss']
})
export class PhoneEnrollmentExtStep2Component implements OnInit {
    notBlankValidator = new NotBlankGenericFieldValidator()
    //public rblRep: ValidatedRadioButtonModel[] = []
    //public rdlHMO: ValidatedRadioButtonModel[] = []
    public rblBenf: ValidatedRadioButtonModel[] = []
    validatedDate = new ValidatedDateTextField()

    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef

    enrollment: EnrollmentViewModel = {} as EnrollmentViewModel
    //public IsRblRepYes: boolean
    //public IsRblRepNo: boolean
    //public IsRdlHMOYes: boolean
    // public MedicareNum: ValidatedRadioButtonModel[] = []
    public IsrblBenfYes: boolean
    public IsrblBenfNo: boolean
    public showsubmit: boolean
    hasError: boolean
    ErrorMessages: any[]
    spnIsBeneficiary: string
    spnIsAre: string
    spnYourMediBeneficiary: string
    spnDoDoes: string
    spnIsAreCapt: string
    spnIsBeneficiaryYour: string
    spnIsQualify: string
    spnYouThey: string
    spnYourTheir: string
    spnHasHave: string
    spnIsReside: string
    spnyouheshe: string
    spnyouthey: string
    spnyouthem: string
    spnyourhisher: string
    spnyouhimher: string
    spnIsBeneficiaryYou: string
    spnIsEmployeeYour: string
    spnYourenrollee: string
    AgentFullName: string
    showHover: boolean = false
    insuranceComapny: string
    checkPlanyear: boolean = false
    showQtip: boolean = false
    ShowCurrentYearScript: boolean = false
    isAEPVisible: boolean = false
    reasonCode: string = ''
    periodSelected: string = ''
    disableEffectiveDate: boolean = false
    dateField: boolean = false
    rblvalidPeriod: ValidatedRadioButtonModel[] = []
    IsRblvalidPeriodYes: boolean
    IsRblvalidPeriodNo: boolean

    constructor(public _global: PortalGlobals, private router: Router, private _enrollementGateway: EnrollmentGateway) {
        //this.rblRep.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        //this.rdlHMO.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblBenf.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblvalidPeriod.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })

        //this.IsRblRepYes = false
        //this.IsRblRepNo = false
        //this.IsRdlHMOYes = false
        //this.IsrblBenfYes = true
        this.IsRblvalidPeriodYes = false
        this.IsRblvalidPeriodNo = false
        this.showsubmit = false
    }
    ngOnInit() {
        this.showQtip = false
        this.isAEPVisible = false
        if (this._global.currentUser.insuranceCompanyName !== undefined) {
            this.insuranceComapny = this._global.currentUser.insuranceCompanyName
        }
        this.enrollment = this._enrollementGateway.getEnrollmentViewModel()
        if (this.enrollment.PLANYEAR === this._global.AEPPlanYearValue) {
            this.checkPlanyear = true
        } else {
            this.checkPlanyear = false
        }

        if (Number(this._global.selectedPlanYear) === this._global.PreviousPlanYear) {
            this.ShowCurrentYearScript = true
        }
        let today = new Date()
        if (this.enrollment.APPDT === null || this.enrollment.APPDT === undefined) {
            this.enrollment.APPDT = today
        }

        if (this.enrollment.RBLVALIDPERIOD !== '' && this.enrollment.RBLVALIDPERIOD !== null && this.enrollment.RBLVALIDPERIOD !== undefined) {
            this.ShowGroupOptionsEP(this.enrollment.RBLVALIDPERIOD)
        }
        if (this.enrollment.ELECTION !== '' && this.enrollment.ELECTION !== null && this.enrollment.ELECTION !== undefined) {
            this.periodSelectdChanged(this.enrollment.ELECTION)
        }

        //this.ShowGroupOptions(this.enrollment.RBLHEALTHCOVERAGE)
        //this.ShowOptionsHMO(this.enrollment.RBLHMO)
        this.ShowGroupOptionsEnrolle(this.enrollment.RBLBENEFICIARYPART)
        this.AgentFullName = this.enrollment.APPFN + ' ' + this.enrollment.APPLN

        this.setScript()
    }

    //ShowGroupOptions(isgroup: string) {
    //    if (isgroup === 'Yes') {
    //        this.IsRblRepYes = true
    //        this.IsRblRepNo = false

    //    }
    //    if (isgroup === 'No') {
    //        this.IsRblRepYes = false
    //        this.IsRblRepNo = true
    //    }
    //    this.enrollment.RBLHEALTHCOVERAGE = isgroup

    //}
    //ShowOptionsHMO(ishmo: string) {
    //    if (ishmo === 'Yes') {
    //        this.IsRdlHMOYes = true;
    //    }
    //    if (ishmo === 'No') {
    //        this.IsRdlHMOYes = false
    //    }
    //    this.enrollment.RBLHMO = ishmo

    //}
    ShowGroupOptionsEnrolle(isenrolle: any) {
        if (isenrolle === 'Yes') {
            this.IsrblBenfYes = true
            this.IsrblBenfNo = false
            this.showsubmit = this.enrollment.RBLVALIDPERIOD == 'Yes' ? true : this.showsubmit
        }
        if (isenrolle === 'No') {
            this.IsrblBenfYes = false
            this.IsrblBenfNo = true
            this.showsubmit = false
        }
        this.enrollment.RBLBENEFICIARYPART = isenrolle
    }
    onBack(): void {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/ext/Step1'])
    }
    formSubmit(): void {
        this.validateForm()
    }
    validateForm() {
        this.hasError = false
        this.ErrorMessages = [] as any[]
        if (this.enrollment.HICN === undefined || this.enrollment.HICN === '' || this.enrollment.HICN === null) {
            this.ErrorMessages.push('Medicare number is required')
            this.hasError = true
            this.focusableEleTop.nativeElement.focus()
        } else if (this.enrollment.HICN.indexOf('-') > -1) {
            this.ErrorMessages.push('Please enter Medicare Number without -')
            this.hasError = true
            this.focusableEleTop.nativeElement.focus()
        }

        /*
        if (this.enrollment.CURRENTGENDER == "4" && (this.enrollment.CURRENTGENDEROTH == undefined
            || this.enrollment.CURRENTGENDEROTH == '')) {
            this.ErrorMessages.push('Different Gender Identity Required')
            this.hasError = true

        }
        if (this.enrollment.GENDERNPRONOUN == "4" && (this.enrollment.GENDERNPRONOUNOTH == undefined
            || this.enrollment.GENDERNPRONOUNOTH == '')) {
            this.ErrorMessages.push('Different Self-Identity is Required')
            this.hasError = true

        }
        */

        //if (this.enrollment.RBLHEALTHCOVERAGE === undefined || this.enrollment.RBLHEALTHCOVERAGE === ''
        //    || this.enrollment.RBLHEALTHCOVERAGE === null) {
        //    this.ErrorMessages.push('Please select health coverage')
        //    this.hasError = true
        //    this.focusableEleTop.nativeElement.focus()
        //}
        if (this.enrollment.MEDA !== undefined && this.enrollment.MEDA !== null) {
            let parta = moment(this.enrollment.MEDA).format('MM/DD/YYYY')
            if (parta === null || parta === '') {
                this.ErrorMessages.push('Invalid PartA date')
                this.hasError = true
                this.focusableEleTop.nativeElement.focus()
            }
        }
        if (this.enrollment.MEDB !== undefined && this.enrollment.MEDB !== null) {
            let partb = moment(this.enrollment.MEDB).format('MM/DD/YYYY')
            if (partb === null || partb === '') {
                this.ErrorMessages.push('Invalid PartB date')
                this.hasError = true
                this.focusableEleTop.nativeElement.focus()
            }
        }
        if (this.enrollment.ELECTION === undefined || this.enrollment.ELECTION === null || this.enrollment.ELECTION === '') {
            this.ErrorMessages.push('Election Status is required')
            this.hasError = true
        }
        if (this.enrollment.ELECTION !== undefined && this.enrollment.ELECTION !== '') {
            if (this.enrollment.SEPREASONTEXT === undefined || this.enrollment.SEPREASONTEXT === '') {
                this.ErrorMessages.push('Enrollment Criteria is required')
                this.hasError = true
            }
            if (this.enrollment.ELECTION === 'Special') {
                if (this.dateField === true) {
                    if (this.enrollment.SEPEFFDT === undefined || this.enrollment.SEPEFFDT === null) {
                        this.ErrorMessages.push('SEP date is required')
                        this.hasError = true
                    }
                }
            }
        }

        if (this.enrollment.APPDT === undefined || this.enrollment.APPDT === null) {
            this.ErrorMessages.push('Application Date is required')
            this.hasError = true
        }
        if (this.enrollment.EFFDT === undefined || this.enrollment.EFFDT === null) {
            this.ErrorMessages.push('Effective Date is required')
            this.hasError = true
        } else {
            if (this.enrollment.EFFDT.getDate() != 1) {
                this.ErrorMessages.push('The Effective Date must fall on the first of the month.')
                this.hasError = true
            }
            if (this.enrollment.EFFDT.getFullYear() != this._global.selectedPlanYear) {
                this.ErrorMessages.push('The Effective Date must be in the same year as the Plan Year')
                this.hasError = true
            }
            // var date = new Date()
            //if (this.enrollmentViewModel.EFFDT.getMonth() <= (date.getMonth() - 1) || this.enrollmentViewModel.EFFDT.getMonth() <= (date.getMonth() + 3)) {
            //    this.ErrorMessages.push('The Effective Date can be 1 month before the current month and 3 months after the current month.')
            //    this.hasError = true

            //}
        }
        if (this.enrollment.EFFDT && this.enrollment.APPDT && this.enrollment.EFFDT <= this.enrollment.APPDT) {
            this.ErrorMessages.push('Application date must be prior to the effective date.')
            this.hasError = true
        }

        // check authorize reprenatative
        //if (this.IsRblRepNo) {
        //    if (this.enrollment.RBLHMO === undefined || this.enrollment.RBLHMO === ''
        //        || this.enrollment.RBLHMO === null) {
        //        this.ErrorMessages.push('Please select member advantage plan')
        //        this.hasError = true
        //        this.focusableEleTop.nativeElement.focus()
        //    }

        //}

        if (!this.hasError) {
            this.saveData()
        }

        // return this.hasError
    }
    saveData() {
        //if (this.enrollment.MEDA === undefined ||
        //    this.enrollment.MEDA === null) {
        //    this.enrollment.MEDA = ''
        //}
        //if (this.enrollment.MEDB === undefined ||
        //    this.enrollment.MEDB === null) {
        //    this.enrollment.MEDB = ''
        //}
        this.enrollment.SUBMISSIONTYPECODE = 'PROSPECT'
        this.enrollment.STEPCODE = '22'
        this.enrollment.ADMINID = this._global.currentUser.userProfileId
        //this.enrollment.AGENTID = String(this._global.currentUser.userProfileId)
        this.enrollment.USERPROFILEID = this._global.currentUser.userProfileId
        this.enrollment.INSURANCECOMPID = Number(this._global.currentUser.insuranceCompanyId)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        if (this.enrollment.PLANST === '0') {
            this.enrollment.PLANST = ''
        }
        if (this.enrollment.MAILST === '0') {
            this.enrollment.MAILST = ''
        }
        if (this.enrollment.APPST === '0') {
            this.enrollment.APPST = ''
        }
        this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
        this._enrollementGateway.CheckDuplicateEnrollment(this.enrollment).subscribe(
            (model: string[]) => {
                if (model !== undefined && model !== null && model.length !== 0) {
                    this.ErrorMessages = model
                    this.hasError = true
                    this.focusableEleTop.nativeElement.focus()
                    //this.loading = false
                } else {
                    this._enrollementGateway.SubmitEnrollmentData(this.enrollment).subscribe((model: SubmitEnrollmentDataResponse) => {
                        let response = model
                        if (response !== undefined) {
                            if (response.Errors !== undefined && response.Errors.length > 0) {
                                this.hasError = false

                                for (let i = 0; i < response.Errors.length; i++) {
                                    this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                                }
                                this.hasError = true
                                this.focusableEleTop.nativeElement.focus()
                            } else {
                                if (response.EnrollmentKey !== undefined && response.EnrollmentKey !== '' && response.EnrollmentKey !== null) {
                                    this.enrollment.ENROLLKEY = response.EnrollmentKey
                                    this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
                                    this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/ext/Step3'])
                                } else {
                                    this.ErrorMessages.push('Error while submitting data, please try again.')
                                    this.hasError = true
                                    this.focusableEleTop.nativeElement.focus()
                                }
                            }
                        } else {
                            this.ErrorMessages.push('Error while submitting data, please try again.')
                            this.hasError = true
                            this.focusableEleTop.nativeElement.focus()
                        }
                    })
                }
            },
            (err) => {
                //this.loading = false
            }
        )
        //  this.router.navigate(['enrollment/phone-enrollment/Step3'])
        // }
    }
    setScript() {
        if (this.enrollment.RBLBENFE === 'Yes') {
            this.spnIsBeneficiary = 'you '
            this.spnIsAre = 'are '
            this.spnYourMediBeneficiary = 'your '
            this.spnDoDoes = 'Will '
            this.spnIsAreCapt = 'Are '
            this.spnIsBeneficiaryYour = 'your '
            this.spnIsQualify = 'qualify '
            this.spnYouThey = 'you '
            this.spnYourTheir = 'your '
            this.spnHasHave = 'have '
            this.spnIsReside = ''
            this.spnyouheshe = 'you'
            this.spnyourhisher = 'your'
            this.spnyouhimher = 'you'
            this.spnIsBeneficiaryYou = 'you '
            this.spnIsEmployeeYour = 'your '
            this.spnYourenrollee = 'your'
            this.spnyouthey = 'you'
            this.spnyouthem = 'you'
        }
        if (this.enrollment.RBLBENFE === 'No' && this.AgentFullName !== ' ' && this.AgentFullName !== 'undefined undefined') {
            this.spnIsBeneficiary = this.AgentFullName
            this.spnIsAre = 'is '
            this.spnYourMediBeneficiary = 'the Medicare Beneficiary’s '
            this.spnDoDoes = 'Will '
            this.spnIsAreCapt = 'Is '
            this.spnIsBeneficiaryYour = this.AgentFullName
            this.spnIsQualify = 'qualifies '
            this.spnYouThey = 'they '
            this.spnYourTheir = 'their '
            this.spnHasHave = 'has '
            this.spnIsReside = '(s)'
            this.spnIsBeneficiaryYou = 'the enrollee '
            this.spnIsEmployeeYour = 'enrollee’s'
            this.spnYourenrollee = 'the enrollee'
            if (this.enrollment.TITLE === 'Mr' || this.enrollment.APPGEN === 'M') {
                this.spnyouheshe = 'he'
                this.spnyourhisher = 'his'
                this.spnyouhimher = 'him'
                this.spnyouthey = 'they'
                this.spnyouthem = 'them'
            } else if (this.enrollment.TITLE === 'Mrs' || this.enrollment.TITLE === 'Ms' || this.enrollment.APPGEN === 'F') {
                this.spnyouheshe = 'she'
                this.spnyourhisher = 'her'
                this.spnyouhimher = 'her'
                this.spnyouthey = 'they'
                this.spnyouthem = 'them'
            } else {
                this.spnyouheshe = '(he/she)'
                this.spnyourhisher = '(his/her)'
                this.spnyouhimher = '(him/her)'
                this.spnyouthey = 'they'
                this.spnyouthem = 'them'
            }
        }
        if (this.enrollment.RBLBENFE === 'No' && (this.AgentFullName === ' ' || this.AgentFullName === 'undefined undefined')) {
            this.spnIsBeneficiary = 'enrollee’s name'
            this.spnIsAre = 'is'
            this.spnYourMediBeneficiary = 'the Medicare Beneficiary’s'
            this.spnDoDoes = 'Will '
            this.spnIsAreCapt = 'Is'
            this.spnIsBeneficiaryYour = ' enrollee '
            this.spnIsQualify = 'qualifies '
            this.spnYouThey = 'they'
            this.spnYourTheir = 'their'
            this.spnHasHave = 'has'
            this.spnIsReside = '(s)'
            this.spnyouheshe = '(he/she)'
            this.spnyourhisher = '(his/her)'
            this.spnyouhimher = '(him/her)'
            this.spnIsBeneficiaryYou = 'the enrollee'
            this.spnIsEmployeeYour = 'enrollee’s'
            this.spnYourenrollee = 'the enrollee'
            this.spnyouthey = 'they'
            this.spnyouthem = 'them'
        }
    }
    toggleImage() {
        this.showHover = !this.showHover
    }
    medicareNumberValueChange(event: any) {
        //if (hicn.indexOf('-') >= 0) {
        //    hicn = event.replace('-', '')
        //}
        this.enrollment.HICN = event.toUpperCase()
    }

    HICNBlur() {
        if (this.enrollment.HICN !== undefined && this.enrollment.HICN.indexOf('-') >= 0) {
            let re = /\-/gi
            let updatedHICN = this.enrollment.HICN.replace(re, '')
            this.enrollment.HICN = updatedHICN.toUpperCase()
        }
    }

    keyDownFunction(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.formSubmit()
        }
    }

    AEPVisible(event: any) {
        if (event) {
            this.isAEPVisible = true
        }
    }

    reasonCodeChanged(SelReasonCode: any) {
        this.enrollment.SEPREASONTEXT = SelReasonCode.text
        this.enrollment.ELECTIONTYPEID = SelReasonCode.id
        this.enrollment.SEPREASONCD = SelReasonCode.value
        this.reasonCode = this.enrollment.ELECTIONTYPEID + '|' + this.enrollment.SEPREASONCD
        this.reasonCode = SelReasonCode.id + '|' + SelReasonCode.value
    }

    periodSelectdChanged(period: string) {
        this.periodSelected = this.enrollment.ELECTION = period
        let currDate = new Date()
        if (this.periodSelected === 'OpenEnrollment') {
            if (this.enrollment.EFFDT != new Date(currDate.getFullYear() + 1, 0, 1)) {
                if (currDate.getMonth() > 3) this.enrollment.EFFDT = new Date(currDate.getFullYear() + 1, 0, 1)
            }
            this.disableEffectiveDate = true
        } else {
            if (currDate.getMonth() == 11) {
                this.enrollment.EFFDT = new Date(currDate.getFullYear() + 1, 0, 1)
            } else {
                this.enrollment.EFFDT = new Date(currDate.getFullYear(), currDate.getMonth() + 1, 1)
            }

            //If Year of Effective Date is not same as that of selected plan Year, default effective date will be 01/01 of next year
            if (this._global.selectedPlanYear !== undefined && this._global.selectedPlanYear !== 0) {
                if (this.enrollment.EFFDT.getFullYear() !== this._global.selectedPlanYear) {
                    if (this._global.selectedPlanYear > currDate.getFullYear()) this.enrollment.EFFDT = new Date(currDate.getFullYear() + 1, 0, 1)
                }
            }
            this.disableEffectiveDate = false
        }
    }

    hasDateField(datefield: boolean) {
        this.dateField = datefield
    }

    sepdatechange(option: Date) {
        this.enrollment.SEPEFFDT = option
    }

    ShowGroupOptionsEP(val: any) {
        if (val === 'Yes') {
            this.IsRblvalidPeriodYes = true
            this.IsRblvalidPeriodNo = false
            this.showsubmit = true
        }
        if (val === 'No') {
            this.IsRblvalidPeriodYes = false
            this.IsRblvalidPeriodNo = true
            this.showsubmit = false
        }
        this.enrollment.RBLVALIDPERIOD = val
    }

    appRecievedDateChange(event: any) {
        this.enrollment.APPDT = event
        if (
            this.enrollment.APPDT !== undefined &&
            this.enrollment.APPDT !== null &&
            (this.enrollment.EFFDT === undefined || this.enrollment.EFFDT === null)
        ) {
            let currDate = event
            if (currDate.getMonth() == 11) {
                this.enrollment.EFFDT = new Date(currDate.getFullYear() + 1, 0, 1)
            } else {
                this.enrollment.EFFDT = new Date(currDate.getFullYear(), currDate.getMonth() + 1, 1)
            }

            //If Year of Effective Date is not same as that of selected plan Year, default effective date will be 01/01 of next year
            if (this._global.selectedPlanYear !== undefined && this._global.selectedPlanYear !== 0) {
                if (this.enrollment.EFFDT.getFullYear() !== this._global.selectedPlanYear) {
                    if (this._global.selectedPlanYear > currDate.getFullYear()) this.enrollment.EFFDT = new Date(currDate.getFullYear() + 1, 0, 1)
                }
            }
        }
    }
}
